import { z } from "zod"

export const UpsertKlaviyoIntegration = z.object({
  apiKey: z.string(),
})
